import styled from "styled-components";

export const TermStyled = styled.div`
	& {
		color: white;
		/* padding: 2rem 0; */
		display: flex;
		/* flex-direction: column; */
		column-gap: 1.2rem;

		label {
			font-size: 16px;
		}
		.term-condition {
			color: var(--color-brand-0);
			cursor: pointer;
		}
	}
`;

export const ModalTermStyled = styled.div`
	& {
		color: white;
		padding: 2rem 0;
		display: flex;
		flex-direction: column;
		row-gap: 1.2rem;
	}
`;
